import { EmptyStateContainer, StyledText } from "./style";
import EmptyState from "../../../assets/images/empty-state-mess.png";
import { useTranslation } from "react-i18next";

type Props = {
  message?: string;
};

export const ApplicationsEmptyState: React.FC<Props> = ({ message }) => {
  const { t } = useTranslation();
  return (
    <EmptyStateContainer>
      <img src={EmptyState} alt="Empty" />
      <StyledText>
        {message || t("components.application.emptyState")}
      </StyledText>
    </EmptyStateContainer>
  );
};
